export default __webpack_public_path__ + "static/media/info_icon.9feb4748.svg";